import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Setup from "./setup/index.md";
import Tutorials from "./tutorials/index.md";
import Guides from "./guides/index.md";
import References from "./references/index.md";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "integrate"
    }}>{`Integrate`}</h2>
    <p>{`In this section, you can learn how to get set up to make API calls, jump start your development with quick start tutorials, read guides on advanced topics, and browse our API endpoints and responses.`}</p>
    <Setup mdxType="Setup" />
    <Tutorials mdxType="Tutorials" />
    <Guides mdxType="Guides" />
    <References mdxType="References" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      